import { render } from "./InformationSecurity.vue?vue&type=template&id=71caa89c&scoped=true"
import script from "./InformationSecurity.vue?vue&type=script&lang=js"
export * from "./InformationSecurity.vue?vue&type=script&lang=js"

import "./InformationSecurity.vue?vue&type=style&index=0&id=71caa89c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-71caa89c"

export default script